<p-tag [value]="tagValue" [severity]="tagSeverity" icon="pi pi-circle-fill"/>
